/*
 * @fileOverView Form component definition
 */

import Vue from 'vue';
import Form from 'components/foundation/forms/form/form.mixin';
import Analytics from 'mixins/analytics.mixin';

/**
 * [Form Vue]
 * @type {class}
 */
Vue.component('form-form-assembly-vue', {
  mixins: [
    Analytics,
    Form
  ],

  props: {
    'customButtonText': null
  },

  mounted() {
    // Form Assembly's script handles validation and submission - that's why it
    // isn't called here.

    const $submitButton = $('.wForm').find('form').find('input[type="submit"]');

    if ($submitButton) {
      // Allows for the submit button to be controlled by a CMS field.
      if (this.customButtonText) {
        $submitButton.attr('value', this.customButtonText);
      }
    }

    // The legacy CMS silenced the alert function on the form pages because an
    // invalid form triggers an alert. So we're doing the same, but in addition,
    // we're also handling the invalid form at this time. There is nothing else
    // we can listen for to determine if/when a wFORMS form is invalid.
    window.alert = message => {
      this.handleInvalid();
    };
  },

  methods: {
    initAnalytics() {
      const form = this.$el.querySelector('form');

      this.setFormAnalyticsData({
        "formType": "Form - Form Assembly",
        "formName": window.mjffPageData ? window.mjffPageData.pageName : null
      });
      this.pushFormViewedEvent();
      this.$nextTick(() => {
        this.attachFormStartedEvent(form, this.pushFormStartedEvent);
      });

      form.addEventListener('submit', e => {
        this.populateHiddenFormFields(form);
      });
    },

    handleInvalid() {
      // The wFORMS global variable contains the needed information.
      if (wFORMS && wFORMS.instances.validation.length) {
        const errors = wFORMS.instances.validation[0].elementsInError;
        const errorMap = {};

        // Manipulate the error data into what the analytics code expects.
        for (const id in errors) {
          if (errors.hasOwnProperty(id)) {
            errorMap[id] = errors[id].rule;
          }
        }

        // Reports which fields were invalid to analytics.
        this.pushFormValidationFailedEvent(errorMap);
      }
    }
  }
})
